(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-material-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-tw-material]').forEach(function (root) {
    // Build the layer stack when it scrolls into view.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { root.classList.add('is-built'); io.unobserve(root); }
        });
      }, { threshold: 0.3 });
      io.observe(root);
    } else {
      root.classList.add('is-built');
    }

    // Tab switching.
    var tabs = root.querySelectorAll('.tw-material__tab');
    var panels = root.querySelectorAll('.tw-material__panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-tab');
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-panel') === id);
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-preorder-countdown"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('.tw-preorder[data-target]');
  if (!sections.length) return;

  var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function setDigit(el, value) {
    if (el.textContent === value) return;
    el.classList.add('is-changing');
    setTimeout(function () {
      el.textContent = value;
      requestAnimationFrame(function () {
        el.classList.remove('is-changing');
      });
    }, 220);
  }

  function tick(section, target, refStart) {
    var now = Date.now();
    var diff = target - now;
    var digits = section.querySelectorAll('[data-unit]');
    var fill = section.querySelector('[data-tide-fill]');
    var marker = section.querySelector('[data-tide-marker]');

    if (diff <= 0) {
      digits.forEach(function (el) { setDigit(el, '00'); });
      var lbl = section.querySelector('.tw-preorder__countdown-label');
      if (lbl) lbl.textContent = 'Launching today';
      if (fill)   fill.style.width = '100%';
      if (marker) marker.style.left = '100%';
      return false;
    }

    var s = Math.floor(diff / 1000);
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600);  s -= h * 3600;
    var m = Math.floor(s / 60);    s -= m * 60;
    digits.forEach(function (el) {
      switch (el.getAttribute('data-unit')) {
        case 'days':    setDigit(el, pad(d)); break;
        case 'hours':   setDigit(el, pad(h)); break;
        case 'minutes': setDigit(el, pad(m)); break;
        case 'seconds': setDigit(el, pad(s)); break;
      }
    });

    /* Tide fill: 0% at refStart, 100% at target. Clamp at edges. */
    if (fill && marker) {
      var span = target - refStart;
      var pct = span > 0 ? ((now - refStart) / span) * 100 : 0;
      pct = Math.max(0, Math.min(100, pct));
      fill.style.width = pct + '%';
      marker.style.left = pct + '%';
    }

    return true;
  }

  sections.forEach(function (section) {
    var raw = section.getAttribute('data-target');
    var target = new Date(raw).getTime();
    if (isNaN(target)) return;

    var windowDays = parseInt(section.getAttribute('data-tide-window'), 10) || 120;
    var refStart = target - windowDays * 86400 * 1000;

    /* Editorial date "26 — 06 — 2026" */
    var dateEl = section.querySelector('[data-date-display]');
    if (dateEl) {
      var dt = new Date(raw);
      var dd = pad(dt.getDate());
      var mm = pad(dt.getMonth() + 1);
      var yyyy = dt.getFullYear();
      dateEl.textContent = dd + ' — ' + mm + ' — ' + yyyy;
    }

    tick(section, target, refStart);
    var iv = setInterval(function () {
      if (tick(section, target, refStart) === false) clearInterval(iv);
    }, 1000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-product-design-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-tw-design-story]').forEach(function (root) {
    var track = root.querySelector('[data-tw-design-track]');
    var cards = root.querySelectorAll('.tw-design-story__card');
    var dots  = root.querySelectorAll('.tw-design-story__dot');
    var prevBtn = root.querySelector('[data-tw-design-prev]');
    var nextBtn = root.querySelector('[data-tw-design-next]');
    if (!track || !cards.length) return;

    function cardStep() {
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      return cards[0].getBoundingClientRect().width + gap;
    }

    function scrollByCards(dir) {
      track.scrollBy({ left: dir * cardStep(), behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCards(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCards(1); });

    if (dots.length) {
      var syncDots = function () {
        var idx = Math.round(track.scrollLeft / cardStep());
        dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === idx); });
      };
      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(syncDots);
      }, { passive: true });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-reels-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-tw-reels]').forEach(function (root) {
    var track = root.querySelector('[data-tw-reels-track]');
    var cards = root.querySelectorAll('.tw-reels__card');
    var dots  = root.querySelectorAll('.tw-reels__dot');
    var prevBtn = root.querySelector('[data-tw-reels-prev]');
    var nextBtn = root.querySelector('[data-tw-reels-next]');
    if (!track || !cards.length) return;

    function cardStep() {
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      return cards[0].getBoundingClientRect().width + gap;
    }
    function scrollByCards(dir) {
      track.scrollBy({ left: dir * cardStep(), behavior: 'smooth' });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCards(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCards(1); });

    if (dots.length) {
      var syncDots = function () {
        var idx = Math.round(track.scrollLeft / cardStep());
        dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === idx); });
      };
      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(syncDots);
      }, { passive: true });
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
